import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

export default class UnavailableProductsCardStyle {
	public static getStyle(options: { theme: ITheme }): string {
		const { color, spacing } = options.theme;

		return css`
			:host {
				display: flex;
				flex-direction: column;
			}

			kompis-product-row {
				margin-bottom: ${spacing.space100 / 16}rem;
			}

			.checkboxLabel {
				margin-top: ${1 / 16}rem;
			}

			.card {
				margin-top: ${spacing.space50 / 16}rem;
			}

			.unavailable-list {
				list-style: none;
				padding: 0;
				margin: 0;
			}

			.productRowContainer {
				margin-bottom: ${spacing.space100 / 16}rem;
				border-bottom: ${1 / 16}rem solid ${color.neutral.grey200};
			}

			.productRowContainer:last-child {
				border: none;
			}

			.help > :not(:last-child) {
				margin-bottom: ${spacing.space100 / 16}rem;
			}

			.help {
				display: flex;
				flex-direction: column;
				margin-bottom: ${spacing.space150 / 16}rem;
				margin-top: ${spacing.space150 / 16}rem;
			}
		`;
	}
}
